import {useState, useMemo, useCallback, useRef} from "react";
import { FaPlay } from "react-icons/fa6";
import { IoDownloadOutline, IoCloudOfflineOutline } from "react-icons/io5";
import { ScrollShadow, Link, Listbox, ListboxItem } from "@nextui-org/react";
import LoadingCommon from "@/components/shared/loadingCommon";
var _ = require('lodash');
import moment from 'moment';

const formatDuration = (durationInSeconds) => {
    const duration = moment.duration(Number(durationInSeconds), 'seconds');
    const formattedTime = moment.utc(duration.asMilliseconds()).format('mm:ss');
    return formattedTime;
};

export default function Audios({ audiosData, isHasHeader }) {
    const audiosValidData = _.filter(audiosData, audioData => audioData?.mediaEmbed)
    const [selectedKeys, setSelectedKeys] = useState(new Set([_.head(audiosValidData)?.id]));
    const iframeRef = useRef(null);

    const selectedMediaEmbed = useMemo(() => {
        return _.find(audiosData, audioData => {
            return audioData.id === Array.from(selectedKeys).join(", ");
        })?.mediaEmbed || '';
    }, [selectedKeys, audiosData]);

    const handleItemClick = useCallback((audioId) => {
        const currentSelectedId = Array.from(selectedKeys).join(", ");
        if (audioId !== currentSelectedId) {
            setSelectedKeys(new Set([audioId]));
        }
    }, [selectedKeys]);

    if (audiosData.length === 0) {
        return <LoadingCommon />;
    }

    return (
        <>
            {!isHasHeader && (
                <div className={"flex items-center bg-primary w-full h-10 justify-center"}>
                    <Link href={"/audio"} className="text-white font-bold text-lg">
                        AUDIO
                    </Link>
                </div>
            )}
            {selectedMediaEmbed ? (
                <div ref={iframeRef}>
                    <div dangerouslySetInnerHTML={{ __html: selectedMediaEmbed }} />
                </div>
            ) : (
                <div className="h-24 grid content-center text-amber-500">
                    <IoCloudOfflineOutline className="text-5xl mx-auto" />
                </div>
            )}

            <ScrollShadow hideScrollBar className="h-[250px] w-screen sm:w-full">
                <Listbox
                    variant="flat"
                    selectionMode="single"
                    selectedKeys={selectedKeys}
                    itemClasses={{
                        selectedIcon: 'hidden'
                    }}
                    className="bg-white"
                >
                    {audiosData.map((audio) => {
                        const classColorActive = Array.from(selectedKeys).join(", ") === audio?.id ? 'text-green-700' : 'text-news';
                        return (
                            <ListboxItem
                                key={audio.id}
                                onClick={() => handleItemClick(audio.id)}
                            >
                                <div className="flex gap-1">
                                    <p className={`inline-block my-auto ${classColorActive}`}><FaPlay /></p>
                                    <p className={`w-8/12 truncate ${classColorActive}`}>{audio?.title}</p>
                                    <p className="px-2">{formatDuration(audio.mediaDuration)}</p>
                                    <Link href={audio.mediaUrl} className="block"><IoDownloadOutline className={`${classColorActive}`} /></Link>
                                </div>
                            </ListboxItem>
                        );
                    })}
                </Listbox>
            </ScrollShadow>
        </>
    );
}